<div class="modal-header">
    <h4 class="modal-title">{{'AssignReferral' | translateOrgSpecific }}</h4>
    <a><i class="fas fa-times closebtn" (click)="activeModal.dismiss()" style="cursor: pointer;"></i></a>
</div>

<div class="modal-body">
    <form style="position: relative;" #assignForm="ngForm" (ngSubmit)="assignForm.form.valid">


        <div class="row">
            <div class="col-md-4 form-group  required">
                <label class="control-label label-page" for="title">{{ 'Clinician' | translateOrgSpecific }}</label>
            </div>
            <div class="col-md-8 form-group">
                <multi-select-dropdown #clinician="ngModel" name="clinician" [valueField]="'clinicianId'"
                    [textField]="'clinicianName'" [dataSource]="clinicianList" [showSelectAll]="true"
                    [(ngModel)]="clinicians">
                </multi-select-dropdown>
            </div>
        </div>

    </form>
</div>

<div class="modal-footer">
    <div>
        <button (click)="activeModal.dismiss()" class="btn btn-sm btn-apportis-tertiary btn-cancel" type="submit">{{
            'Cancel' | translateOrgSpecific }}</button>
        <button style="width:100px;" class="btn btn-sm btn-apportis-tertiary " type="submit" (click)="onSubmit()"
            [disabled]="!assignForm.form.valid">{{ 'Submit' | translateOrgSpecific }}</button>
    </div>
</div>